    <div class="login-container">
      <mat-card class="login-card">
        <mat-card-header>
          <mat-card-title class="login-title">
            <mat-icon>directions_car</mat-icon>
            AvtoTime
          </mat-card-title>
          <mat-card-subtitle>Бронирование автомобилей</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="form" (ngSubmit)="onSubmit()" class="login-form">
            <mat-form-field appearance="outline" class="login-field">
              <mat-label>Логин</mat-label>
              <input matInput formControlName="username" autocomplete="username">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="form.get('username')?.hasError('required')">
                Введите логин
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="login-field">
              <mat-label>Пароль</mat-label>
              <input matInput [type]="hidePassword ? 'password' : 'text'" 
                     formControlName="password" autocomplete="current-password">
              <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" 
                      type="button" aria-label="Показать пароль">
                <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              <mat-error *ngIf="form.get('password')?.hasError('required')">
                Введите пароль
              </mat-error>
            </mat-form-field>
            <div class="login-error" *ngIf="errorMessage">
              {{ errorMessage }}
            </div>
            <button mat-raised-button color="primary" type="submit" 
                    class="login-button" [disabled]="form.invalid || loading">
              <mat-spinner *ngIf="loading" diameter="20" class="login-spinner"></mat-spinner>
              <span *ngIf="!loading">Войти</span>
            </button>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
  
